import { CommonModule } from '@angular/common'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { Router } from '@angular/router'
import { EffectsModule } from '@ngrx/effects'
import {
  BaseSiteService,
  I18nModule,
  LanguageService,
  provideConfig,
  RoutingService,
  SiteContextInterceptor,
  SiteContextUrlSerializer
} from '@spartacus/core'
import { IconModule, SiteContextComponentService } from '@spartacus/storefront'
import { EbSiteContextInterceptor } from './interceptors/eb-site-context.interceptor'
import { EbBaseSiteService } from './services/eb-base-site.service'
import { EbCountryService } from './services/eb-country.service'
import { EbLanguageService } from './services/eb-language.service'
import { EbSiteContextComponentService } from './services/eb-site-context-component.service'
import { EbSiteContextUrlSerializer } from './services/eb-site-context-url-serializer'
import { EbSiteContextSelectorComponent } from './site-context-selector/eb-site-context-selector.component'
import { effects } from './store/effects'

@NgModule({
  imports: [EffectsModule.forFeature(effects), CommonModule, IconModule, I18nModule],
  providers: [
    EbLanguageService,
    provideConfig({
      cmsComponents: {
        CMSSiteContextComponent: {
          component: EbSiteContextSelectorComponent
        }
      }
    }),
    {
      provide: LanguageService,
      useExisting: EbLanguageService
    },
    {
      provide: BaseSiteService,
      useExisting: EbBaseSiteService
    },
    {
      provide: SiteContextComponentService,
      useExisting: EbSiteContextComponentService
    },
    {
      provide: SiteContextInterceptor,
      useClass: EbSiteContextInterceptor
    },
    {
      provide: SiteContextUrlSerializer,
      useClass: EbSiteContextUrlSerializer
    },
    {
      provide: APP_INITIALIZER,
      useFactory: EbCountryService.initialCountryHandling,
      multi: true,
      deps: [EbCountryService, Router, SiteContextUrlSerializer]
    }
  ]
})
export class EbSiteContextModule {}
